<template>
  <div></div>
</template>
<script lang="ts">
import { defineComponent, onMounted } from 'vue';
import { useRouter, useRoute } from 'vue-router';
import { UserApi, Configuration } from '../api';

export default defineComponent({
  setup() {
    const router = useRouter();
    const route = useRoute();
    const baseUrl = process.env.VUE_APP_BASE_URL;

    if (!baseUrl) {
      throw new Error(
        'VUE_APP_BASE_URL environment variable is not set. Please configure the environment variable for this build.'
      );
    }

    const config = new Configuration({
      basePath: baseUrl,
    });

    const api = new UserApi(config);

    async function validateToken() {
      try {
        // Get authToken and sessionId from query parameters
        const authToken = route.query.authToken as string;
        const sessionId = route.query.sessionId as string;

        if (!authToken || !sessionId) {
          console.error(
            'AutoLogin: authToken or sessionId missing from query parameters'
          );
          router.push({ name: 'Login' });
          return;
        }

        const response = await api.validateGet(authToken, sessionId);
        const responseData = (response as any).data;

        if (!responseData || !responseData.token) {
          console.error('AutoLogin: Token not returned from validation');
          router.push({ name: 'Login' });
          return;
        }

        const jwt = responseData.token;
        localStorage.setItem('jwt', jwt);

        if (responseData.facilityId) {
          localStorage.setItem(
            'dp_facilityId',
            responseData.facilityId.toString()
          );
        }
        if (responseData.courseId) {
          localStorage.setItem('dp_courseId', responseData.courseId.toString());
        }

        router.push({
          name: 'MainLayout',
          query: {
            facilityId: responseData.facilityId,
            courseId: responseData.courseId,
          },
        });
      } catch (error: any) {
        console.error('AutoLogin validation failed:', error);
        router.push({ name: 'Login' });
      }
    }

    onMounted(() => {
      validateToken();
    });
  },
});
</script>
<style scoped></style>
